<div class="aar-toggle-group">
  <button *ngFor="let item of items" mat-mini-fab [class.active]="item.value==value" (click)="toggleButton(item);">{{item.label}}</button>
</div>